import { SVGIcon, SVGIcons } from 'components/SvgIcon/SVGIcon';

export const Carret: React.FunctionComponent = () => {
    return <SVGIcon icon={SVGIcons.CARRET} data-testid="carret" />;
};
